module.exports = __webpack_public_path__ + "static/media/pipe_up.7e59b539.png";


//////////////////
// WEBPACK FOOTER
// ./src/flappybird/pipe_up.png
// module id = 246
// module chunks = 0